import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.43.37 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V143_37: ChangelogAdvancedPayload = {
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v14336",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v14336",
  stats: [
    {
      value: 3,
      labelKey: "changelog.advanced.stat.newFeatures",
      accentColor: "#0F6E56"
    },
    {
      value: 2,
      labelKey: "changelog.advanced.stat.improvements",
      accentColor: "#185FA5"
    },
    {
      value: 33,
      labelKey: "changelog.advanced.stat.fixesRelease",
      accentColor: "#E24B4A"
    }
  ],
  tabs: [
    {
      id: "video",
      labelKey: "changelog.advanced.tab.video",
      count: 0,
      countBadgeKey: "changelog.advanced.tabCount.new",
      accentColor: "#0F6E56",
      kind: "video",
      youtubeVideoId: "M2jSuHww18s",
      videoHeadingKey: "changelog.advanced.v14336.video.heading",
      videoCaptionKey: "changelog.advanced.v14336.video.caption",
      youtubeOpenLabelKey: "changelog.advanced.v14336.video.openYoutube",
      bulletsAfterVideoLabelKey: "changelog.advanced.v14336.video.inThisVideo",
      items: [
        {
          textKey: "changelog.advanced.v14336.video.bullet.1"
        },
        {
          textKey: "changelog.advanced.v14336.video.bullet.2"
        },
        {
          textKey: "changelog.advanced.v14336.video.bullet.3"
        }
      ]
    },
    {
      id: "ux",
      labelKey: "changelog.advanced.tab.ux",
      count: 2,
      sectionLabelKey: "changelog.advanced.section.ux",
      accentColor: "#5F5E5A",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.v14336.ux.1"
        },
        {
          textKey: "changelog.advanced.v14336.ux.2"
        }
      ]
    },
    {
      id: "fatturazione",
      labelKey: "changelog.advanced.tab.billing",
      count: 3,
      sectionLabelKey: "changelog.advanced.section.billing",
      accentColor: "#BA7517",
      kind: "list",
      items: [
        {
          textKey: "changelog.advanced.v14336.billing.1"
        },
        {
          textKey: "changelog.advanced.v14336.billing.2"
        },
        {
          textKey: "changelog.advanced.v14336.billing.3"
        }
      ]
    },
    {
      id: "fix",
      labelKey: "changelog.advanced.tab.fixes",
      count: 33,
      sectionLabelKey: "changelog.advanced.v14336.fixes.section",
      accentColor: "#E24B4A",
      kind: "fixes-summary",
      fixesSummaryKey: "changelog.advanced.v14336.fixes.summary"
    }
  ]
};
